import { render, staticRenderFns } from "./AppInfoModal.vue?vue&type=template&id=102ddc72"
import script from "./AppInfoModal.vue?vue&type=script&lang=js"
export * from "./AppInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports